import { render, staticRenderFns } from "./SelectorTree.vue?vue&type=template&id=5c22aa3e&scoped=true"
import script from "./SelectorTree.js?vue&type=script&lang=js&external"
export * from "./SelectorTree.js?vue&type=script&lang=js&external"
import style0 from "./SelectorTree.vue?vue&type=style&index=0&id=5c22aa3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22aa3e",
  null
  
)

export default component.exports